module.exports = __webpack_public_path__ + "img/planet-avatar-01.cff2ba64.png";